import React from "react";

import { CollapseHeader, FormCollapse } from "components/Form";
import { FinanceSubModalSection } from "constants/settings";
import { useSectionHelper, SectionToggleState } from "hooks";

import { InterestSettingForm } from "components/Form/FormikControls/Interest";

interface BusinessInterestSectionProps {
  sectionHelper: SectionToggleState;
  namespace: string;
}

export const BusinessInterestSection: React.FC<
  BusinessInterestSectionProps
> = ({ sectionHelper, namespace }) => {
  const { isOpen, onToggle } = useSectionHelper(
    sectionHelper,
    FinanceSubModalSection.INTEREST,
  );

  const header = <CollapseHeader title="Interest" />;

  return (
    <FormCollapse
      isOpen={isOpen}
      onToggle={onToggle}
      header={header}
      dataTour="interestCollapse"
    >
      <InterestSettingForm
        namespace={namespace}
        toolip="Enter interest settings specific to this business. These will override the defaults set for your agency."
        useBusinessCheckbox
      />
    </FormCollapse>
  );
};
